///<amd-module name="Core/Medius.Core.Web/Scripts/Medius/components/generic/editor" />

import {create as createGenericModel} from "Core/Medius.Core.Web/Scripts/Medius/components/generic/model";

export function create (bindingParameters: any, viewModel: any) {
    const editor = createGenericModel(bindingParameters, viewModel);
    editor.Template = ["edit", editor.Component].join("-");
    return editor;
}